import { useCallback } from "react";
import { useDispatch } from "react-redux";

import SetAdvisor from "data/advisor/actions";
import useCurrentUser from "data/advisor/useCurrentUser";

import { useAsyncCall, useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

export function useOnboardingContentPreference() {
  const mutationFactory = useCallback(() => {
    const query = `mutation updateOnboardingContentPreference($visible: Boolean, $incrementClick: Boolean) {
          updateOnboardingContentPreference(visible: $visible, incrementClick: $incrementClick) {
            visible
            clickCount
          }
        }`;

    const resolver = ({ data: { updateOnboardingContentPreference } }) => {
      return { data: updateOnboardingContentPreference };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const dispatch = useDispatch();
  const user = useCurrentUser();
  const [call, loading] = useAsyncCall();
  const mutate = useMutation(mutationFactory);

  const onUpdateCompleted = useCallback(
    (data) => {
      dispatch(
        SetAdvisor({
          ...user,
          onboardingContent: { ...(user.onboardingContent || {}), ...data },
        })
      );
    },
    [dispatch, user]
  );

  return {
    isUpdatingUseCaseVisibility: loading,
    updateOnboardingContentPreference: async ({ visible, incrementClick }) => {
      return call(async () => {
        try {
          const { data } = await mutate({ visible, incrementClick });

          onUpdateCompleted(data);

          return data;
        } catch (e) {
          console.error("Error updating onboarding content preference", e);

          return null;
        }
      });
    },
  };
}
export default useOnboardingContentPreference;
